module.exports = __webpack_public_path__ + "static/media/BladeHW_NewBayonetArm_install.ebaf16d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/wiper-blades-adapters/BladeHW_NewBayonetArm_install.jpg
// module id = 816
// module chunks = 0